@let sectionIsInitialised =
  !!storeSectionState() && formConfig() && formConfig().length > 0;

@if (sectionIsInitialised) {
  <form
    #form="ngForm"
    novalidate
    class="flex flex-col gap-1"
  >
    <div class="flex flex-col gap-y-2">
      @for (item of formConfig(); track item.id) {
        @switch (item.type) {
          @case ('text') {
            <nsp-text-input
              [id]="item.id"
              [name]="item.id"
              [label]="item.label"
              [labelWidthPercentage]="item.labelWidthPercentage"
              [required]="item.required ?? false"
              [readonly]="item.readonly ?? false"
              [disabled]="item.disabled ?? false"
              [value]="parsers[item.type](storeSectionState()[item.id]?.value)"
              [ngModel]="
                parsers[item.type](storeSectionState()[item.id]?.value)
              "
            />
          }

          @case ('number') {
            <nsp-number-input
              [id]="item.id"
              [name]="item.id"
              [label]="item.label"
              [labelWidthPercentage]="item.labelWidthPercentage"
              [required]="item.required ?? false"
              [readonly]="item.readonly ?? false"
              [disabled]="item.disabled ?? false"
              [unit]="item.unit"
              [value]="parsers[item.type](storeSectionState()[item.id]?.value)"
              [ngModel]="
                parsers[item.type](storeSectionState()[item.id]?.value)
              "
            />
          }

          @case ('checkbox') {
            <nsp-checkbox-input
              [id]="item.id"
              [name]="item.id"
              [label]="item.label"
              [value]="storeSectionState()[item.id]?.value ? true : false"
              [ngModel]="storeSectionState()[item.id]?.value ? true : false"
              class="w-full justify-items-center justify-self-center"
            />
          }
        }
      }
    </div>
  </form>
}
